<template>
  <div id="Zones" class="col-12 p-0">
    <div class="row-center">
      <div>
        <!-- CREAR -->

        <!-- 1 MODAL CREACIÓN ZONA -->

        <b-modal id="modal-create-zn" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">agregar Zona</h2>
            <input
              v-model="nameLN"
              type="text"
              class="form-control mt-5 input-vp2"
              placeholder="Nombre de la Zona"
            />
            <b-form-select
              class="mt-3"
              v-model="selected"
              :options="options"
            ></b-form-select>

            <div style="display: flex;" class="mt-4">
              <button
                :disabled="nameLN === '' || selected === { id: null, name: '' }"
                @click="nextStep1LN('next')"
                type="button"
                class="button-primary enviar-mensaje mr-4 pt-1 pb-1"
                style="border: none"
              >
                <span class="cta">Guardar Cambios</span>
              </button>
              <button
                type="button"
                class="button-secundary ml-4"
                style="margin: auto"
                @click="$bvModal.hide('modal-create')"
              >
                <span class="cta" >Cancelar</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 2 MODAL CREACIÓN ZONA -->

        <b-modal id="modal-create2-zn" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-5 font-weight-bold">
              ¿Estás seguro de guardar está Zona?
            </h3>
            <p class="pt-5">
              <span>
                <span class="font-weight-bold">Nombre Zona:</span>
                {{ nameLN }}
              </span>
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Línea de Negocio:</span>
              {{ selected.name }}
            </p>

            <div style="display: flex;" class="pt-2">
              <button
                type="button"
                class="button-secundary mr-4"
                style="margin: auto"
                @click="nextStep1LN('previous')"
              >
                <span class="cta" style="width: 100%">Seguir editando</span>
              </button>
              <button
                @click="nextStep1LN('save')"
                type="button"
                class="button-primary enviar-mensaje ml-4"
                style="border: none"
              >
                <span class="cta" style="width: 100%">Guardar cambios</span>
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 3 MODAL PROCESO EXITOSO -->

        <b-modal id="modal-success" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/checkbox-circle-line.svg"
            />
            <h3 class="pt-5 font-weight-bold">¡Proceso exitoso!</h3>
            <p class="pt-5">{{ message.message }}</p>
            <button
              @click="$bvModal.hide('modal-success')"
              type="button"
              class="button-primary enviar-mensaje"
              style="border: none"
            >
              <span class="cta" style="width: 100%">Entendido</span>
            </button>
          </div>
        </b-modal>

        <!-- 3 MODAL PROCESO FALLIDO -->

        <b-modal v-if="error.trace" id="modal-fail" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/close.svg"
              width="20%"
            />
            <h3 class="pt-5 font-weight-bold">¡Proceso fallido!</h3>
            <p class="pt-5">{{ error.trace.message[0] }}</p>
            <button
              class="mt-2 mb-5 col-6 btn btn-danger"
              @click="$bvModal.hide('modal-fail')"
            >
              Entendido
            </button>
          </div>
        </b-modal>

        <!-- EDITAR/ELIMINAR -->

        <!-- 1 MODAL EDICIÓN ZONA -->

        <b-modal id="modal-edit" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <h2 class="text-uppercase font-weight-bold">Editar Zona</h2>
            <input
              v-model="nameLN"
              type="text"
              class="form-control mt-5 input-vp2"
              placeholder="Nombre de la Zona"
            />
            <b-form-select
              class="mt-3"
              v-model="selected"
              :options="options"
            ></b-form-select>
            <div style="display: flex;" class="mt-4">
              <button
                :disabled="nameLN === '' || selected === { id: null, name: '' }"
                @click="nextStep2LN('next')"
                type="button"
                class="button-primary enviar-mensaje mr-4"
                style="border: none"
              >
                <span class="cta">Guardar Cambios</span>
              </button>
              <button
                class="delete button-primary enviar-mensaje ml-4"
                type="button"
                @click="nextStep2LN('nextD')"
              >
                <img
                  src="@/assets/images/icons/delete_trash_white.svg"
                />
                <span class="cta ml-2"> Borrar Zona</span>                
              </button>
            </div>
          </div>
        </b-modal>

        <!-- 2 MODAL EDICIÓN ZONA -->

        <b-modal id="modal-edit2" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-2 font-weight-bold">
              ¿Estás seguro de modificar la Zona?
            </h3>
            <p class="pt-5">
              <span class="">Nombre: <b class="text-uppercase">{{ nameLN }}</b></span>
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Linea de Negocio:</span>
              {{ selected.name }}
            </p>

            <div style="width: 100%; display: flex; margin-top: 32px">
              <button
                type="button"
                class="button-secundary"
                style="margin: auto"
                @click="nextStep2LN('previous')"
              >
                <span class="cta" style="width: 100%">Seguir editando</span>
              </button>

              <button
                @click="nextStep2LN('edit')"
                type="button"
                class="button-primary enviar-mensaje"
                style="border: none"
              >
                <span class="cta" style="width: 100%">Guardar cambios</span>
              </button>              
            </div>
          </div>
        </b-modal>

        <!-- 4 MODAL ELIMINAR ZONA -->

        <b-modal id="modal-delete" hide-footer centered>
          <div class="col-12 d-flex flex-column align-items-center">
            <img
              class="centerImg1"
              src="@/assets/images/icons/warning_.svg"
              width="15%"
            />
            <h3 class="pt-2 font-weight-bold">
              ¿Estás seguro de eliminar la Zona?
            </h3>
            <p class="pt-2 text-danger">
              Al confirmar no podrás recuperar los cambios.
            </p>
            <p class="pt-2">
              <span class="font-weight-bold">Nombre Zona:</span>
              {{ nameLN }}
            </p>
            <p style="font-size: 16px">
              <span class="font-weight-bold">Linea de Negocio:</span>
              {{ selected.name }}
            </p>
            <div style="display: flex;" class="mt-2">
              <button
                type="button"
                class="button-secundary mr-4"
                style="margin: auto"
                @click="nextStep2LN('previous')"
              >
                <span class="cta" >No borrar</span>
              </button>
              <button
                class="delete button-primary enviar-mensaje ml-4"
                type="button"
                @click="nextStep2LN('delete')"
              >
                <img
                  src="@/assets/images/icons/delete_trash_white.svg"
                  alt=""
                />
                <span class="cta ml-2"> Borrar Zona</span>                
              </button>
            </div>
          </div>
        </b-modal>
      </div>
    </div>
    <div class="row">
      <SelectSettings />
      <!-- Boton Crear Linea de Negocio -->
      <div class="col-lg-4 col-sm-12 mt-4">
        <AddCategory text="Agregar Zona +" @nuevo="create"></AddCategory>
      </div>
    </div>
    <div class="row">      
      <div class="col-md-8 col-sm-12">
        <div class="mb-4 card-personalizada">
          <div class="card-header card-header-left">
            <h3 style="color:color: #263238;">Lista de Zonas</h3>
          </div>
          <div class="col-12">
            <div class="buscar-empleado mt-4 mb-4">
              <div class="input-group-prepend">
                <span class="icon icon-search1"></span>
              </div>
              <input
                type="search"
                placeholder="Buscar Zona"
                aria-label="Buscar Zona"
                autocomplete="off"
                class="form-control body_regular"
                v-model="datatable.filter"
                style="border: 0px"
                @keydown="startTipyng()"
                @keyup="finishTipyng()"
              />
            </div>
          </div>
          <div class="mt-5" v-if="loading" id="loader"></div>
          <div v-else class="col-12 ml-1 mt-2 mb-1 mr-2">
            <datatable
              :columns="datatable.columns"
              :data="datatable.rows"
              :filter="datatable.filter"
              :per-page="datatable.perPage"
              :page="datatable.page"
              class="col-12 mt-5 table table-hover table-borderless"
            >
              <template slot-scope="{ row, columns }">
                <tr @click="editLineOfBussiness(row)">
                  <template>
                    <datatable-cell
                      v-for="(column, j) in columns"
                      :key="j"
                      :column="column"
                      :row="row"
                    >
                    </datatable-cell>
                  </template>
                </tr>
              </template>
            </datatable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import SelectSettings from "@/components/platformSettings/selectSettings.vue";
import AddCategory from "@/components/core/button/add-category.vue";
export default {
  name: "LineBusiness",
  components: {
    SelectSettings,
    AddCategory
  },
  data() {
    return {
      selected: { id: null, name: "" },
      options: [
        {
          value: { id: null, name: "" },
          text: "Seleccione una linea de Negocio",
        },
      ],
      indexRow: 0,
      nameLN: "",
      modalCreateNew: "",
      datatable: {
        total: 18,
        filter: "",
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      },
    };
  },
  beforeMount() {
    this.loadRows();
    this.callData();
  },
  computed: {
    ...mapState("modPlatformSettings", [
      "lineDeals",
      "zones",
      "zone",
      "loading",
      "error",
      "message",
    ]),

    checkEdit: function () {
      return this.nameLN === "";
    },
  },
  methods: {
    ...mapActions("modPlatformSettings", [
      "actGetZones",
      "actLineDeals",
      "actSaveZone",
      "actGetZone",
      "actActZone",
      "actDelZone",
      "actSetMessage",
      "actSetError",
    ]),

    startTipyng() {
      clearTimeout(this.runTime);
    },
    finishTipyng() {
      this.runTime = setTimeout(() => {
        this.getFilterDp();
      }, 500);
    },

    create() {
      this.nameLN = "";
      (this.selected = { id: null, name: "" }),
        this.$root.$emit("bv::show::modal", "modal-create-zn");
    },

    nextStep1LN(x) {
      let data = {
        name: this.nameLN,
        pro_line_deal_id: this.selected.id,
      };
      switch (x) {
        case "next":
          this.$root.$emit("bv::hide::modal", "modal-create-zn");
          this.$root.$emit("bv::show::modal", "modal-create2-zn");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-create2-zn");
          this.$root.$emit("bv::show::modal", "modal-create-zn");
          break;
        case "save":
          this.actSaveZone(data).then(() => {
            if (this.error.data) {
              this.nameLN = "";
              this.selected = { id: null, name: "" };
              this.$root.$emit("bv::hide::modal", "modal-create2-zn");
              this.$root.$emit("bv::show::modal", "modal-fail");
              this.loadRows();
              this.callData();
            } else {
              this.nameLN = "";
              this.selected = { id: null, name: "" };
              this.$root.$emit("bv::hide::modal", "modal-create2-zn");
              this.$root.$emit("bv::show::modal", "modal-success");
              this.loadRows();
              this.callData();
            }
          });

          break;
        default:
      }
    },
    callData(data) {
      if (data == undefined) {
        data = {
          page: this.datatable.page,
        };
      }
      this.actGetZones(data).then(() => {
        this.zones.data.data.forEach((x) => {
          this.datatable.rows.push({
            id: x.id,
            name: x.name,
            name_line: x.name_line_deal,
          });
        });
      });
    },
    loadRows() {
      this.options = [
        {
          value: { id: null, name: "" },
          text: "Seleccione una linea de Negocio",
        },
      ];
      let filter = {
        filter: "filter/false",
      };
      this.actLineDeals(filter).then(() => {
        this.lineDeals.data.forEach((x) => {
          this.options.push({
            value: { id: x.id, name: x.name },
            text: x.name,
          });
        });
      });
      this.datatable = {
        total: 18,
        filter: "",
        perPage: 10,
        last_page: 2,
        page: 1,
        columns: [],
        rows: [],
      };
      this.datatable.columns = [
        {
          label: "Zona",
          field: "name",
          align: "left",
          headerClass: "theading",
        },
        {
          label: "Línea de Negocio",
          field: "name_line",
          align: "left",
          headerClass: "theading",
        },
      ];
    },
    newLineDeal() {
      this.nameLN = "";
      this.$root.$emit("bv::show::modal", "modal-create-lb");
    },

    editLineOfBussiness(row) {
      this.actGetZone(row.id).then(() => {
        this.nameLN = this.zone.name;
        this.options.forEach((x) => {
          if (x.value.id == this.zone.pro_line_deal_id) {
            this.selected = x.value;
          }
        });
        this.$root.$emit("bv::show::modal", "modal-edit");
      });
    },
    nextStep2LN(x) {
      let data = {
        id: this.zone.id,
        name: this.nameLN,
        pro_line_deal_id: this.selected.id,
      };

      switch (x) {
        case "next":
          this.$root.$emit("bv::hide::modal", "modal-edit");
          this.$root.$emit("bv::show::modal", "modal-edit2");
          break;
        case "previous":
          this.$root.$emit("bv::hide::modal", "modal-edit2");
          this.$root.$emit("bv::hide::modal", "modal-delete");
          this.$root.$emit("bv::show::modal", "modal-edit");
          break;
        case "edit":
          this.actActZone(data)
            .then(() => {
              this.nameLN = "";
              this.$root.$emit("bv::hide::modal", "modal-edit2");
              this.$root.$emit("bv::show::modal", "modal-success");
              this.loadRows();
              this.callData();
            })
            .catch((response) => {
              this.nameLN = "";
              this.actSetMessage(response).then(() => {
                this.$root.$emit("bv::hide::modal", "modal-edit2");
                this.$root.$emit("bv::show::modal", "modal-fail");
                this.loadRows();
                this.callData();
              });
            });
          break;
        case "nextD":
          this.$root.$emit("bv::hide::modal", "modal-edit");
          this.$root.$emit("bv::show::modal", "modal-delete");
          break;
        case "delete":
          this.actDelZone(data.id)
            .then(() => {
              this.nameLN = "";
              this.$root.$emit("bv::hide::modal", "modal-delete");
              this.$root.$emit("bv::show::modal", "modal-success");
              this.loadRows();
              this.callData();
            })
            .catch((error2) => {
              let error = {
                trace: {
                  message: [error2.response.data.message],
                },
              };
              this.nameLN = "";
              this.actSetError(error).then(() => {
                this.$root.$emit("bv::hide::modal", "modal-delete");
                this.$root.$emit("bv::show::modal", "modal-fail");
                this.loadRows();
                this.callData();
              });
            });
          break;
        default:
      }
    },
  },
};
</script>

<style lang="scss">
#Zones {

    .buscar-empleado {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 8px 12px;

    position: relative;
    width: 428px !important;
    height: 44px;
    //left: 30px;
    top: calc(50% - 44px / 2);
    margin-bottom: 24px;

    background: #ffffff;
    /* content/03 */

    border: 1px solid #b0bec5;
    border-radius: 22px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 1;
    margin: 16px 0px;
  }
  .buscar-empleado .form-control {
    border: 0px !important;
    font-family: Ubuntu !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-size: 16px !important;
    line-height: 28px !important;
  }

  .card-header-left {
    /* Neutral / Gray blue light */
    background: #f5f5f5;
    /* Inside Auto Layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;
    border-bottom: none;

    widows: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }

  .card-header-text {
    /* Header Tablas */

    font-style: normal;
    //background: #F5F5F5;
    font-size: 16px;
    /* identical to box height */
    /* Alert/Succes */
    color: #263238 !important;
    width: 100%;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
  }
  .card-personalizada {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0px;
    position: static;
    background: #ffffff;
    border: 0px solid #eceff1 !important;
    box-sizing: border-box;
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 12px !important;
    flex: none;
    order: 0;
    flex-grow: 0;
    //margin: 24px 0px;
  }

  select.custom-select {
    padding: 10px 10px;
    font-size: 15px;
    height: 50px;
    border-radius: 10px;
  }
  .table-views {
    box-shadow: 0px 6px 24px rgba(110, 116, 134, 0.2);
    border-radius: 8px;
    padding: 0;
    margin: 30px 5px;
    .t-head {
      background-color: #f5f5f5;
      padding: 5px 15px;
      text-align: left;
    }
    input {
      padding: 10px 10px;
      font-size: 15px;
      height: 50px;
      border-radius: 10px;
    }
    thead tr {
      background-color: #eef2fa;
      border-radius: 10px;
      text-align: left;
    }
    .theading {
      padding: 15px 15px;
    }
    tbody tr {
      border-radius: 10px;
    }
    tbody tr td {
      padding: 15px 15px;
      cursor: pointer;
    }
    tbody tr:hover {
      background-color: #f5f5f5;
    }
  }
}
</style>